import MultipageDropdown from './MultipageDropdown';

export type { Option } from './MultipageDropdown';

export default MultipageDropdown;
